<p-dialog header="運輸急單註記" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%' }">
  <h2>Booking 單號：{{ booking?.bookingNo }}</h2>
  <div>
    <p-table #detailDataTable laasDataTableSetting [tableKey]="preferenceKey" [defaultColumns]="columns" [value]="tmpDetails" class="datatable">
      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="columns"
          [dataTable]="detailDataTable">
        </laas-table-column-toggle>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn
            pReorderableColumn [attr.field]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr>
          <td *ngFor="let col of columns">
            <div [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'priority'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:priorityOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'urgentFlag'">
                <p-dropdown [options]="priorityOptions" [(ngModel)]="rowData.urgentFlag"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [showClear]="true" appendTo="body"
                  [ngModelOptions]="{standalone: true}">
                </p-dropdown>
              </ng-container>
              <ng-container *ngSwitchCase="'doStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:DOStatusOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shipNotes'">
                <div class="overflow-text">
                  {{ displayMessageArray(rowData[col.field]) | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':timezone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'array'">
                    <ng-container *ngIf="rowData[col.field].length > 0; else displayEmpty">
                      <ng-container *ngFor="let item of rowData[col.field]; index as i">
                        <div class="overflow-text">
                          {{ i + 1 }}. {{ item + '\t\n'}}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #displayEmpty>
                -
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" style="text-align: center;">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="mt-2 text-center">
    <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
      (click)="confirmBtnClick($event)"></button>
    <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"
      (click)="cancelBtnClick($event)"></button>
  </div>
</p-dialog>
